module.exports = __webpack_public_path__ + "static/media/sev.74c98897.gif";